import React, {useEffect, useRef, useState} from "react";
import {classNames} from "shared/lib/classNames/classNames";
import {ReactComponent as Logo} from "shared/assets/icons/LigalTimesLogo.svg";
//import {AppLink} from "shared/ui/AppLink/AppLink";
import cls from "./Header.module.scss";
import {AppLink} from "shared/ui/AppLink/AppLink";


interface HeaderProps {
    className?: string
}

export const Header = ({className}: HeaderProps) => {
    const [headerOpen, setHeaderOpen] = useState(false);

    const menuRef = useRef(null);

    const closeMenu = (e: any) => {
        if (e.target === menuRef.current) {
            setHeaderOpen((prevState) => !prevState);
            document.body.classList.toggle("with-open-menu");
        }
    }

    const onToggleMenu = (e: any) => {
        setHeaderOpen((prevState) => !prevState);
        document.body.classList.toggle("with-open-menu");
    }

    // useEffect(() => {
    //     if (headerOpen && menuRef.current) {
    //         menuRef?.current.addEventListener("click", closeMenu);
    //     }
    //     return () => menuRef?.current.removeEventListener("click", closeMenu);
    // }, [headerOpen]);


    return (
        <header ref={menuRef} className={classNames(cls.header, {[cls.header_open]: headerOpen}, [className])}>
            <div className={classNames("container container__main", {}, [cls.header__container])}>
                <div className={cls.header__logo}>
                    <AppLink href={"/"}>
                        <div className={cls.Logo}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="144" height="42" viewBox="0 0 144 42" fill="none">
                                <path d="M70.705 41.242C69.8773 41.242 69.2059 40.5631 69.2059 39.7257C69.2059 26.9892 69.2059 14.2528 69.2059 1.51628C69.2059 0.678877 69.8773 3.05176e-05 70.705 3.05176e-05C75.7566 3.05176e-05 79.7828 3.05176e-05 85.0544 3.05176e-05C88.0116 3.05176e-05 90.729 0.525662 93.2066 1.57693C95.6843 2.58776 97.8422 4.02314 99.6805 5.88307C101.519 7.743 102.937 9.9264 103.936 12.4333C104.975 14.8997 105.495 17.6087 105.495 20.5604C105.495 23.512 104.975 26.2412 103.936 28.7481C102.937 31.255 101.519 33.4586 99.6805 35.3589C97.8422 37.2189 95.6843 38.6745 93.2066 39.7257C90.729 40.7366 88.0116 41.242 85.0544 41.242C79.7828 41.242 75.7566 41.242 70.705 41.242ZM85.0544 9.58272C82.7687 9.58272 81.9816 9.58272 79.6959 9.58272C79.6959 16.9416 79.6959 24.3004 79.6959 31.6593C81.9816 31.6593 82.7687 31.6593 85.0544 31.6593C87.0525 31.6593 88.7909 31.1741 90.2694 30.2037C91.748 29.2333 92.8869 27.9192 93.6862 26.2614C94.4854 24.5632 94.885 22.6629 94.885 20.5604C94.885 18.4578 94.4854 16.5777 93.6862 14.9199C92.8869 13.2621 91.748 11.9683 90.2694 11.0383C88.7909 10.0679 87.0525 9.58272 85.0544 9.58272Z" fill="white"/>
                                <path d="M12.9777 41.242C12.15 41.242 11.4791 40.5631 11.4791 39.7257C11.4791 29.6983 11.4791 19.6708 11.4791 9.64337C8.62424 9.64337 4.66582 9.64337 1.49785 9.64337C0.67021 9.64337 6.10352e-05 8.96452 6.10352e-05 8.12712C6.10352e-05 5.92351 6.10352e-05 3.71989 6.10352e-05 1.51628C6.10352e-05 0.678878 0.66903 3.05176e-05 1.49667 3.05176e-05C10.893 3.05176e-05 22.4952 3.05176e-05 31.8916 3.05176e-05C32.7192 3.05176e-05 33.3882 0.678878 33.3882 1.51628C33.3882 3.71989 33.3882 5.92351 33.3882 8.12712C33.3882 8.96452 32.718 9.64337 31.8904 9.64337C28.741 9.64337 24.8043 9.64337 21.9691 9.64337C21.9691 19.6708 21.9691 29.6983 21.9691 39.7257C21.9691 40.5631 21.2982 41.242 20.4706 41.242C18.0004 41.242 15.4883 41.242 12.9777 41.242Z" fill="white"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M48.3395 7.88445C57.6504 7.88445 65.1984 15.5215 65.1984 24.9422C65.1984 34.363 57.6504 42 48.3395 42C39.0286 42 31.4806 34.363 31.4806 24.9422C31.4806 15.5215 39.0286 7.88445 48.3395 7.88445ZM48.3395 17.361C44.2013 17.361 40.8466 20.7552 40.8466 24.9422C40.8466 29.1292 44.2013 32.5235 48.3395 32.5235C52.4777 32.5235 55.8323 29.1292 55.8323 24.9422C55.8323 20.7552 52.4777 17.361 48.3395 17.361Z" fill="white"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M125.141 7.88445C134.452 7.88445 142 15.5215 142 24.9422C142 34.363 134.452 42 125.141 42C115.83 42 108.282 34.363 108.282 24.9422C108.282 15.5215 115.83 7.88445 125.141 7.88445ZM125.141 17.361C121.003 17.361 117.648 20.7552 117.648 24.9422C117.648 29.1292 121.003 32.5235 125.141 32.5235C129.279 32.5235 132.634 29.1292 132.634 24.9422C132.634 20.7552 129.279 17.361 125.141 17.361Z" fill="white"/>
                                <path d="M116.59 19.1882C116.59 19.1882 121.58 23.0603 124.811 27.4909C124.811 27.4909 132.658 16.4182 140.505 9.92731" stroke="#262F35" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </AppLink>
                </div>
                <nav className={classNames(cls.mainMenu, {}, [cls.header__menu])}>
                    <li className={cls.mainMenu__item}>
                        <AppLink href={"/"}>
                            Home
                        </AppLink>
                    </li>
                    <li className={cls.mainMenu__item}>
                        <AppLink href={"/about"}>
                            About us
                        </AppLink>
                    </li>
                    <li className={cls.mainMenu__item}>
                        <AppLink href={"/terms"}>
                            Terms & Conditions
                        </AppLink>
                    </li>
                    <li className={cls.mainMenu__item}>
                        <AppLink href={"/policy"}>
                            Privacy Policy
                        </AppLink>
                    </li>

                </nav>
            </div>
        </header>
    );
};
